import styled from '@emotion/styled';
import { bodyLong, subTitle3, title2 } from '@teamsparta/stack-font';
import { vars } from '@teamsparta/stack-tokens';
import { EditorContent } from '@tiptap/react';

export const StyledEditor = styled(EditorContent, {
  shouldForwardProp: (prop) => prop !== 'editable',
})<{ editable: boolean }>`
  width: 100%;

  .tiptap {
    width: 100%;
    min-height: 156px;
    ${bodyLong};
    color: ${vars.neutral[40]};

    &:focus {
      outline: none;
      border: none;
    }

    /* placeholder */
    p.is-editor-empty:first-of-type::before {
      content: attr(data-placeholder);
      float: left;
      height: 0;
      pointer-events: none;
      color: ${vars.neutral[70]};
    }

    /* image */
    img {
      display: block;
      max-width: 100%;
      height: auto;
      margin: 16px 0;

      &.ProseMirror-selectednode {
        outline: ${({ editable }) =>
          editable ? `2px solid ${vars.brand.default}` : 'none'};
      }
    }

    /* heading */
    h1 {
      ${title2};
      margin: 8px 0;
    }

    h2 {
      ${title2};
      margin: 6px 0;
    }

    h3 {
      ${subTitle3};
      margin: 4px 0;
    }

    h1,
    h2,
    h3 {
      color: ${vars.neutral[10]};
    }

    /* horizontal rule */
    hr {
      margin: 16px 0;
      border: none;
      border-bottom: 1px solid ${vars.neutral[80]};
    }

    /* link */
    a {
      color: ${vars.blue[60]};
      text-decoration: underline;
    }

    /* list */
    ul,
    ol {
      padding-inline-start: 16px;
    }

    /* code */
    pre {
      background: ${vars.neutral[90]};
      border-radius: 8px;
      color: ${vars.neutral[0]};
      font-family: 'JetBrainsMono', monospace;
      margin: 12px 0;
      padding: 16px 12px;

      code {
        background: none;
        color: inherit;
        font-size: 0.8rem;
        padding: 0;
      }

      /* Code styling */
      .hljs-comment,
      .hljs-quote {
        color: #616161;
      }

      .hljs-variable,
      .hljs-template-variable,
      .hljs-attribute,
      .hljs-tag,
      .hljs-regexp,
      .hljs-link,
      .hljs-name,
      .hljs-selector-id,
      .hljs-selector-class {
        color: #f98181;
      }

      .hljs-number,
      .hljs-meta,
      .hljs-built_in,
      .hljs-builtin-name,
      .hljs-literal,
      .hljs-type,
      .hljs-params {
        color: #fbbc88;
      }

      .hljs-string,
      .hljs-symbol,
      .hljs-bullet {
        color: #b9f18d;
      }

      .hljs-title,
      .hljs-section {
        color: #faf594;
      }

      .hljs-keyword,
      .hljs-selector-tag {
        color: #70cff8;
      }

      .hljs-emphasis {
        font-style: italic;
      }

      .hljs-strong {
        font-weight: 700;
      }
    }
  }
`;
